import { render, staticRenderFns } from "./ImportActes.vue?vue&type=template&id=82667340&"
import script from "./ImportActes.vue?vue&type=script&lang=js&"
export * from "./ImportActes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports